import { DateTime, Settings } from 'luxon';

Settings.defaultZoneName = 'utc';

DateTime.cast = (dt, format, config) => {
  if (!dt) {
    return null;
  }

  const options = { zone: 'utc', ...config };

  if (dt instanceof DateTime) {
    return dt.zoneName === 'UTC' ? dt : dt.toUTC();
  }

  if (dt instanceof Date) {
    return DateTime.fromJSDate(dt, options);
  }

  if (typeof dt === 'string') {
    return format ? DateTime.fromFormat(dt, format, options) : DateTime.fromISO(dt, options);
  }

  throw new TypeError(`Cannot cast ${dt} to a Luxon DateTime`);
};

DateTime.fromRange = (range) => {
  if (!range) {
    return {};
  }

  const [startDate, endDate] = range.split(' - ')
    .map((dt) => DateTime.cast(dt, 'MM/dd/yyyy').toISODate());

  return { startDate, endDate };
};

DateTime.toUSTime = (dt, options) => {
  return DateTime.cast(dt, 'HH:mm:ss', options)?.toFormat('h:mm a')?.toLowerCase() ?? '';
};

DateTime.prototype.inSameMonth = function inSameMonth(compare) {
  return this.toFormat('yyyyMM') === DateTime.cast(compare)?.toFormat('yyyyMM');
};

DateTime.prototype.inSameDay = function inSameDay(compare) {
  return this.toFormat('yyyyMMdd') === DateTime.cast(compare)?.toFormat('yyyyMMdd');
};

DateTime.prototype.diffDays = function diffDays(compare) {
  if (!(compare instanceof DateTime)) {
    throw new TypeError(`${compare}<${compare.constructor.name}> is not an instance of DateTime`);
  }

  const dateA = this.startOf('day');
  const dateB = (compare || DateTime.now()).startOf('day');
  return dateA.diff(dateB).as('days');
};

DateTime.prototype.isBefore = function isBefore(compare) {
  return this.diffDays(compare) < 0;
};

DateTime.prototype.isAfter = function isAfter(compare) {
  return this.diffDays(compare) > 0;
};

DateTime.prototype.isSameOrAfter = function isSameOrAfter(compare) {
  return this.diffDays(compare) >= 0;
};

DateTime.prototype.isSameOrBefore = function isSameOrBefore(compare) {
  return this.diffDays(compare) <= 0;
};
